import {
  ActionsObservable,
  combineEpics,
  StateObservable
} from 'redux-observable';
import { from, of, timer } from 'rxjs';
import {
  catchError,
  mergeMap,
  startWith,
  switchMap,
  takeUntil
} from 'rxjs/operators';
import axios from '../../axios-pod';
import { IState } from '../../models/states';
import actionTypes from '../../utilities/actionTypes';
import {
  dummyAction,
  fetchAssets,
  fetchAssetsPending,
  fetchAssetsSuccess,
  IEscalateAssets,
  IFetchAssets,
  IResolveAsset,
  ISnoozeAssets,
  updateAssets
} from '../actions/assetActions';

import {
  restoreFilters,
  setAssetsFilters,
  setAssetsFiltersFirstTime
} from '../actions/filterActions';

export const onLoadAssetList = (
  action$: ActionsObservable<IFetchAssets>,
  state$: StateObservable<IState>
) =>
  action$.ofType(actionTypes.FETCH_ASSETS).pipe(
    switchMap((action: IFetchAssets) => {
      let resetFilters = action.resetFilters ? action.resetFilters : false;
      const state = state$.value; // extract the states
      return timer(
        0,
        globalThis.UI_CONFIG ? globalThis.UI_CONFIG.ingest_poll_time : 180000
      ).pipe(
        // timer every n minutes
        // destroy the polling
        takeUntil(action$.ofType(actionTypes.FETCH_ASSETS_REJECTED)),
        switchMap(_ => {
          return from(
            axios.get('/assets', {
              params: {
                screens: state.screens ? state.screens.selectedScreen : '',
                userId: state.user.userInfo.userId
              }
            })
          ).pipe(
            mergeMap(response => {
              const resultArray: any = [
                fetchAssetsSuccess(response.data.result)
              ];
              if (resetFilters) {
                resultArray.push(
                  setAssetsFiltersFirstTime(response.data.result)
                );
                const oldSelectedScreen = localStorage.getItem(
                  'podSelectedScreen'
                );
                // if the selected screen exist and
                if (
                  oldSelectedScreen &&
                  state.screens.selectedScreen &&
                  oldSelectedScreen === state.screens.selectedScreen
                ) {
                  resultArray.push(restoreFilters());
                }
                resetFilters = false; // since in the timer loop it will always call setFiltersFirstTimer.
              } else {
                resultArray.push(setAssetsFilters(response.data.result));
              }
              return resultArray;
            }),
            catchError(error => of(dummyAction(error))), // todo: change this to snackbar error action
            startWith(fetchAssetsPending())
          );
        })
      );
    })
  );

export const onEscalateAssets = (action$: ActionsObservable<IEscalateAssets>) =>
  action$.ofType(actionTypes.ESCALATE_ASSETS).pipe(
    switchMap((action: IEscalateAssets) => {
      return from(axios.post('/escalate', action.payload)).pipe(
        mergeMap((response: any) => {
          const result: any[] = [
            updateAssets(response.data.result),
            fetchAssets(false)
          ];
          return result;
        }),
        catchError(_ => of())
      );
    })
  );

export const onSnoozeAssets = (action$: ActionsObservable<ISnoozeAssets>) =>
  action$.ofType(actionTypes.SNOOZE_ASSETS).pipe(
    switchMap((action: ISnoozeAssets) => {
      return from(axios.post('/snooze_assets', action.payload)).pipe(
        mergeMap((response: any) => {
          return [fetchAssets(false)];
        }),
        catchError(_ => of())
      );
    })
  );

export const onResolveAsset = (action$: ActionsObservable<IResolveAsset>) =>
  action$.ofType(actionTypes.RESOLVE_ASSET).pipe(
    switchMap((action: IResolveAsset) => {
      return from(axios.post('/resolve', action.payload)).pipe(
        mergeMap((response: any) => {
          return [fetchAssets(false)];
        }),
        catchError(_ => of())
      );
    })
  );

export default combineEpics(
  onLoadAssetList,
  onSnoozeAssets,
  onEscalateAssets,
  onResolveAsset
);
